import { Observer } from './../../model/observer';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {
  IBlankslate,
  IDropdown,
  IToast,
  LayoutService,
  ToastService,
} from 'codex-lib';
import { Subscription } from 'rxjs';
import {
  NgbModalConfig,
  NgbModal,
  NgbActiveModal,
} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { NewEnvelopeService } from '../new-envelope/new-envelope.service';
import { TranslateService } from '@ngx-translate/core';
import { TenantCustomizationService } from 'src/app/services/tenant-customization.service';
import { NewEnvelopeSteps } from 'src/app/enum/new-envelope-steps';
import { TableObserverUser } from '../model/table-observer-user';
import { ObserverNotifications } from 'src/app/enum/observer-notifications';
import { WhenWillNotified } from 'src/app/enum/when-will-notified';
import { ModalIntentType } from 'src/app/enum/modal-intent-type.enum';
import { ParticipantTypeEnum } from 'src/app/enum/participant.enum';
import { MainEnvelopeComponent } from 'src/app/main-envelope/main-envelope.component';

@Component({
  selector: 'app-envelope-observer',
  templateUrl: './envelope-observer.component.html',
  styleUrls: ['./envelope-observer.component.scss'],
})
export class ObserverComponent implements OnInit, OnChanges, OnDestroy {
  @Input() observersIsToggled: boolean;
  tableObserverUser: TableObserverUser;
  blankSlate: IBlankslate;
  blankSlateSearch: IBlankslate;
  searchText = '';
  observerUsers: Subscription;
  stepModelSubscription: Subscription;
  checkboxAllElements: boolean;
  activeModal: NgbActiveModal;
  settings: any;
  hiddenPhoneColumn: boolean = false;
  logoPath;
  observerNotifications: number;
  observerModalData: any;
  modalIntentType = ModalIntentType;
  participantType = ParticipantTypeEnum;

  model: {
    envelopeObserver: Array<Observer>;
  };

  dropdownWhenNotified: IDropdown = {
    items: [
      {
        nomeDoItem: 'envelope.observer.sendEachSignature',
        codigo: 1,
      },
      {
        nomeDoItem: 'envelope.observer.sendCompletedEnvelope',
        codigo: 2,
      },
    ],
    displayText: 'nomeDoItem',
    showSearch: false,
    clearSelectionItem: false,
  };

  constructor(
    modalConfig: NgbModalConfig,
    private authService: AuthService,
    private modalService: NgbModal,
    private newEnvelopeService: NewEnvelopeService,
    private translate: TranslateService,
    private toastService: ToastService,
    private layoutService: LayoutService,
    private tenantCustomizationService: TenantCustomizationService,
    private mainEnvelopeComponent: MainEnvelopeComponent
  ) {
    this.model = {
      envelopeObserver: new Array<Observer>(),
    };
    this.tableObserverUser = new TableObserverUser();
    this.checkboxAllElements = false;
    this.observerUsers = this.tableObserverUser.observerUsers.subscribe((x) => {
      this.model.envelopeObserver = x;
      this.model = this.newEnvelopeService.setModelData(this.model);
      this.validateAllCheckboxCheckedTable();
    });

    this.stepModelSubscription =
      this.newEnvelopeService.stepModelSubject.subscribe((modelData) => {
        this.model = modelData;
      });

    if (!this.authService.signUserModel) {
      return;
    }

    this.hiddenPhoneColumn = !this.mainEnvelopeComponent.isSendWhatsapp;

    modalConfig.backdrop = 'static';
    modalConfig.keyboard = false;
  }

  public trackById(index: number, item: Observer) {
    return item?.id ?? index;
  }

  ngOnInit() {
    this.dropdownWhenNotified.containerBody = true;
    this.tenantCustomizationService.tenantLogo.subscribe((imgLogo) => {
      this.layoutService.logoProp.next({ img: imgLogo });
      this.logoPath = imgLogo;
    });

    this.settings = this.newEnvelopeService.getModelData(
      NewEnvelopeSteps.Settings
    ).value;

    Object.assign(
      this.model,
      this.newEnvelopeService.getModelData(
        this.newEnvelopeService.getCurrentStep()
      )
    );
    this.tableObserverUser.addList(this.model.envelopeObserver);

    this.blankSlate = {
      icon: {
        prefix: 'fad',
        iconName: 'user-plus',
      },
      buttonText: 'add',
    };

    this.blankSlateSearch = {
      icon: {
        prefix: 'fad',
        iconName: 'search-minus',
      },
      buttonText: 'cleanSearch',
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['observersIsToggled'] && changes['observersIsToggled'].currentValue === false) {
      this.tableObserverUser.removeAllElements();
    }
  }

  ngOnDestroy(): void {
    this.observerUsers.unsubscribe();
    this.stepModelSubscription.unsubscribe();
  }

  confirmModalClose() {
    this.activeModal.dismiss();
  }

  confirmModalYesClick() {
    this.removeObserver();
    this.activeModal.dismiss();
  }

  showConfirmationDelete(confirmModalContent) {
    this.activeModal = this.modalService.open(confirmModalContent);
  }

  removeObserver() {
    this.model.envelopeObserver
      .filter(item => item.checked)
      .forEach((item) => this.tableObserverUser.removeEl(item));
    this.searchText = '';
    this.checkboxAllElements = false;

    const toastObserversRemoved: IToast = {
      text: this.translate.instant('envelope.observer.toast.removedNotification'),
      autoHide: true,
      type: "success"
    };
    this.toastService.createNewToast(toastObserversRemoved);
  }

  validateAllCheckboxCheckedTable() {
    let allCheked = true;
    allCheked = this.model.envelopeObserver.every(
      (element) => element[TableObserverUser.propCheck]
    );
    if (allCheked || this.checkboxAllElements) {
      this.checkboxAllElements = allCheked;
    }
  }

  onCheckbox(ev, el) {
    const obj = {};
    obj[TableObserverUser.propCheck] = ev;
    this.tableObserverUser.updateElement(el, obj);
    this.searchText = '';
  }

  onCheckboxAll(ev) {
    this.checkboxAllElements = ev;
    const obj = {};
    obj[TableObserverUser.propCheck] = ev;
    this.tableObserverUser.updateElements(obj);
  }

  onSearch(ev) {
    this.searchText = ev;
    this.tableObserverUser.getList(this.searchText);
  }

  anyCheckedElement(): boolean {
    return this.model.envelopeObserver.anyChecked(TableObserverUser.propCheck);
  }

  showAddObserverModal(modalContent) {
    this.activeModal = this.modalService.open(modalContent, {
      size: 'xl',
      scrollable: true,
    });
  }

  closeModalClick() {
    this.activeModal.dismiss();
  }

  submitAddModalClick(event: { data: any, isEdited: boolean }) {
    if (event.isEdited){
      this.tableObserverUser.updateByElementId(event.data);
    }else{
      if(!Array.isArray(event.data))
        return;
      
      event.data.map((observer) => {
        observer[TableObserverUser.propCheck] = false;
        observer.whenWillNotified = WhenWillNotified.sendEachSignature;
        observer.sendCopyFinishedEnvelope = false;
        observer.notifications = ObserverNotifications.sendEachSignature;
      });
      const countNewUsers =
        this.tableObserverUser.mergeList(event.data);
      this.activeModal.close();

      if (countNewUsers > 0) {
        const toastUsersAdded: IToast = {
          text: this.translate.instant(
            'envelope.observer.toast.addedNotification',
            { count: countNewUsers }
          ),
          autoHide: true,
        };
        this.toastService.createNewToast(toastUsersAdded);
      }
    }
  }

  onBlankSlateSearchClick() {
    this.onSearch('');
  }

  onDropdownSendEndEnvelope(selectedItem, observer: Observer) {
    switch (selectedItem.codigo) {
      case 1:
        observer.whenWillNotified = WhenWillNotified.sendEachSignature;
        break;
      case 2:
        observer.whenWillNotified = WhenWillNotified.sendCompletedEnvelope;
        break;
    }
  }

  getSelectedDropdownItem(observer): any {
    if (this.model.envelopeObserver === null) {
      return this.dropdownWhenNotified.items[0];
    } else {
      const selectedItem = this.dropdownWhenNotified.items?.find(
        (item) => item.codigo === observer.whenWillNotified
      );
      return selectedItem === undefined
        ? this.dropdownWhenNotified.items[0]
        : selectedItem;
    }
  }

  onToggle(event, observer: Observer) {
    observer.sendCopyFinishedEnvelope = event;
  }
}
